import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import IconButton from "@material-ui/core/IconButton";
import { Button } from "@material-ui/core";
import RemoveBeaconDialog from "./RemoveBeaconDialog";
import AddBeaconDialog from "./AddBeaconDialog";
import { actions } from "../../actions/beaconActions";
import { useDispatch, useSelector } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";

const BeaconDialog = ({ open, onCancel, submitting, zone }) => {
  const dispatch = useDispatch();

  const [beaconToRemove, setBeaconToRemove] = useState(null);
  const [showAddBeaconDialog, setShowAddBeaconDialog] = useState(false);

  const beaconState = useSelector((x) => x.beacons);
  const onSaveBeacon = useCallback(
    async (x) => {
      const res = await dispatch(actions.saveBeacon({ ...x, zoneId: zone.id }));
      if (res.success) {
        setShowAddBeaconDialog(false);
        dispatch(actions.getBeacon(zone.id));
      }
    },
    [zone, dispatch],
  );

  const onRemoveBeacon = useCallback(
    async (beaconId) => {
      const res = await dispatch(actions.removeBeacon(beaconId));
      if (res.success) {
        setBeaconToRemove(null);
        dispatch(actions.getBeacon(zone.id));
      }
    },
    [zone, dispatch],
  );

  useEffect(() => {
    if (zone) {
      dispatch(actions.getBeacon(zone.id));
    }
  }, [zone]);

  return (
    <Dialog open={open} fullWidth maxWidth={"sm"}>
      <DialogTitle>Lista przypisanych beaconów do {zone.name} </DialogTitle>
      <DialogContent>
        {!beaconState.fetching && beaconState.list.length === 0 && (
          <div>Brak przypisanych beaconów do tej strefy</div>
        )}
        {!beaconState.fetching &&
          beaconState.list.map((x) => (
            <div key={x.id} style={{ display: "flex", alignItems: "center" }}>
              <div style={{ width: 70, paddingRight: 20 }}>
                {x.beaconNumber}
              </div>
              <div>
                <IconButton onClick={() => setBeaconToRemove(x)}>
                  <DeleteForeverIcon />
                </IconButton>
              </div>
            </div>
          ))}
        {beaconState.fetching && <CircularProgress size={40} />}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setShowAddBeaconDialog(true)}
          disabled={submitting}
        >
          Dodaj Beacona
        </Button>
        <Button onClick={onCancel} disabled={submitting}>
          Wyjdź
        </Button>
      </DialogActions>
      {beaconToRemove !== null && (
        <RemoveBeaconDialog
          open={true}
          onCancel={() => {
            setBeaconToRemove(null);
          }}
          onSave={onRemoveBeacon}
          beacon={beaconToRemove}
        />
      )}
      <AddBeaconDialog
        open={showAddBeaconDialog}
        onCancel={() => setShowAddBeaconDialog(false)}
        onSave={onSaveBeacon}
      />
    </Dialog>
  );
};

BeaconDialog.propTypes = {
  zone: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  dispatch: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
};

export default BeaconDialog;
